export class Limit{
  count: number
  limitType: number
  maximumAmount: number
  maximumTotalAmount: number
}
